<template>
    <div class="setting-desc">
        <div class="title-tip">找到靠谱的服务商，从一个有吸引力的标题开始，好的标题有助于你的需求脱颖而出，吸引优质服务商参与。</div>

        <div class="setting-box">
            <div class="setting-box_form">
                <h1 class="form-title">填写需求信息</h1>

                <div class="form-desc-label">请从以下几个方面向学生介绍你的需求，方便服务商更精准的为你报价</div>

                <div class="form-desc">
                    <div class="desc-label">学生会积极参与的需求：</div>

                    <ol>
                        <li v-for="item in descExample" :key="item">{{ item }}</li>
                    </ol>
                </div>

                <div class="form-input">
                    <el-input
                        v-model="task_description"
                        type="textarea"
                        placeholder="请输入"
                        rows="10"
                        resize="none"
                        maxlength="5000"
                        show-word-limit
                    >
                    </el-input>

                    <div class="input-tip">描述内容建议超过10个字，否则学生可能无法理解你的意思</div>
                </div>

                <div class="form-file">
                    <div class="file-top">
                        <div class="file-top_label">附件</div>

                        <!-- <div class="file-top_btn" @click="handleUpload">
                            <i class="el-icon-plus"></i>
                            <span> 上传文件 </span>
                        </div> -->
                        <div style="width: 240px">
                            <UploadFileWidget
                                ref="uploadFileRef"
                                :accept="fileTypes.join(',')"
                                :limit-size="1024 * 1024 * 200"
                                :beforeUpload="handleBeforeUpload"
                                @progress="isUpload = true"
                                @success="handleUploadSuccess"
                                @error="isUpload = false"
                            >
                                <div class="file-top_btn" slot="target">
                                    <i class="el-icon-plus"></i>
                                    <span> 上传文件 </span>
                                </div>
                            </UploadFileWidget>
                        </div>
                    </div>

                    <div class="file-list">
                        <div class="file-item" v-for="(file, index) in task_files" :key="index">
                            <div class="file-item_name">
                                <img :src="getIcon(file.file_name)" alt="" />

                                <!-- 进度条 -->
                                <div class="name-progress" v-if="file.progress < 1">
                                    <div class="progress-bar" :style="{ width: `${file.progress * 100}%` }"></div>
                                </div>

                                <!-- 文件名称 -->
                                <span v-else>{{ file.file_name }}</span>
                            </div>

                            <div class="file-item_operate">
                                <span class="file-size">{{ file.file_size }}</span>
                                <i class="el-icon-delete" @click="handleDeleteFile(index)"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-submit">
                    <div class="submit-btn cancel" @click="handleCancel">取消</div>
                    <div :class="['submit-btn', 'next', { disabled: !isSubmit }]" @click="handleSubmit">提交</div>
                </div>
            </div>

            <div class="setting-box_icon">
                <img src="@/assets/img/task-center/demand-widget-4.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import { formatFileSize, getFileIcon, getFileUnit } from "@/utils/common";
import UploadFileWidget from "@/utils/upload/UploadFileWidget.vue";

export default {
    data() {
        return {
            isUpload: false, // 上传状态
            task_description: "",
            task_files: [
                // {
                //     file_name: "参考.doc",
                //     file_size: "100M",
                //     file_url: "abcdefg.doc",
                // },
            ],
            descExample: ["明确说明你对此任务的经验要求、成交期望", "详细说明需要完成此任务的技能", "你或你的团队希望如何与学生合作"],
            fileTypes: [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".zip", ".7z", ".mp4"],
        };
    },

    components: {
        UploadFileWidget,
    },

    computed: {
        isSubmit() {
            return this.task_description && this.task_files.length > 0;
        },
    },

    methods: {
        getIcon(name) {
            return getFileIcon(getFileUnit(name));
        },

        // 上传前
        handleBeforeUpload(file) {
            if (this.task_files.length >= 2) {
                this.$message.warning("文件已达上限");
                return false;
            }

            if (this.isUpload) {
                this.$message.warning("文件正在上传");
                return false;
            }

            // this.isUpload = true;
            return true;
        },

        // 上传进度条
        handleUploadSuccess(val) {
            this.isUpload = false;

            const fileItem = {
                file_name: val.filename,
                file_size: formatFileSize(val.file.size),
                file_url: val.path,
            };

            this.task_files.push(fileItem);
        },

        // 删除文件
        async handleDeleteFile(index) {
            this.task_files.splice(index, 1);
        },

        customValid() {
            if (this.task_description.length < 10) {
                this.$message.warning("描述内容不能低于10字");
                return false;
            }

            if (this.isUpload) {
                this.$message.warning("文件正在上传");
                return false;
            }

            return true;
        },

        handleCancel() {
            this.$emit("cancel");
        },

        handleSubmit() {
            if (!this.isSubmit || !this.customValid()) return;

            this.$emit("submit", { task_description: this.task_description, task_files: [...this.task_files] });
        },

        initData(data) {
            this.task_description = data.task_description;
            this.task_files = [...data.task_files];
        },
    },
};
</script>

<style lang="scss" scoped>
.setting-desc {
    box-sizing: border-box;
    padding-left: 60px;
    height: 100%;
    width: 100%;

    .title-tip {
        height: 50px;
        background: #eff6ff;
        border-radius: 4px;
        border: 2px solid #c3dfff;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }

    .setting-box {
        display: flex;
        gap: 30px;

        &_form {
            flex: 1;

            .form-title {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 36px;
                color: #333333;
            }

            .el-input {
                width: 480px;
            }

            .form-desc-label {
                color: #666666;
            }

            .form-desc {
                .desc-label {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #666666;
                    padding-block: 30px 16px;
                }

                ol {
                    padding-left: 20px;

                    li {
                        list-style-type: disc;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                        & + li {
                            margin-top: 10px;
                        }
                    }
                }
            }

            .form-input {
                margin-top: 50px;
                position: relative;

                .input-tip {
                    font-size: 12px;
                    color: #909399;
                    position: absolute;
                    bottom: 6px;
                    left: 6px;
                }

                ::v-deep(.el-textarea__inner) {
                    padding-bottom: 30px;
                }

                ::v-deep(.el-textarea .el-input__count) {
                    background: transparent;
                }
            }

            .form-file {
                .file-top {
                    margin-top: 20px;
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    &_label {
                        flex-shrink: 0;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                    }

                    &_btn {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 240px;
                        height: 40px;
                        background: #ffffff;
                        border-radius: 4px;
                        border: 1px solid #e1e3e5;
                        cursor: pointer;

                        span {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }
                    }
                }

                .file-list {
                    .file-item {
                        display: flex;
                        margin-top: 8px;
                        background-color: #f8f8f8;
                        align-items: center;
                        justify-content: space-between;
                        padding-inline: 16px;
                        height: 40px;
                        width: 540px;

                        &_name,
                        &_operate {
                            display: flex;
                            align-items: center;
                            gap: 10px;

                            span {
                                display: inline-block;
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 400;
                                font-size: 12px;
                                color: #333333;
                                overflow: hidden; /* 超出部分隐藏 */
                                white-space: nowrap; /* 不换行 */
                                text-overflow: ellipsis; /* 超出部分用省略号替代 */
                            }
                        }

                        &_name {
                            span {
                                width: 400px;
                            }

                            .name-progress {
                                width: 400px;
                                height: 4px;
                                border: 1px solid #eeeeee;
                                border-radius: 8px;
                                overflow: hidden;

                                .progress-bar {
                                    height: 100%;
                                    background-color: #594fed;
                                }
                            }
                        }

                        &_operate {
                            gap: 30px;

                            span {
                                color: #999999;
                            }

                            .el-icon-delete {
                                cursor: pointer;
                            }
                        }
                    }
                }
            }

            .form-submit {
                margin-top: 80px;
                display: flex;
                gap: 8px;

                .submit-btn {
                    padding: 1px 20px;
                    border-radius: 16px;
                    border: none;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 30px;
                    cursor: pointer;

                    &.cancel {
                        color: #333333;
                        background: #f5f7fa;
                        border: 1px solid #dcdfe6;
                    }

                    &.next {
                        background: #594fed;
                        color: #ffffff;

                        &.disabled {
                            cursor: not-allowed;
                            opacity: 0.4;
                        }
                    }
                }
            }
        }

        &_icon {
            padding-top: 130px;
            width: 550px;
            display: flex;
            align-items: flex-start;

            img {
                width: 550px;
                object-fit: contain;
            }
        }
    }
}
</style>
